export const CONSTANT = {
  // UI feature toggles. Hiding a feature here only removes its menu, routes and
  // entry points from the UI; the feature's code and APIs are left untouched.
  FEATURE_FLAGS: {
    QUOTATION_ENABLED: false,
  },
  LOGIN_REDIRECT_PATH: "/",
  WITHOUT_LOGIN_PAGE: ["/", "/login"],
  DEFAULT_ROUTE: "/dashboard",
  ROLE_OPTIONS: [{ id: "1", name: "Backoffice" }],
  ROLE_TYPE: {
    BACKOFFICE: "1",
    SUPER_ADMIN: "2",
  },
  USER_STATUS: [
    { status: true, value: "Active" },
    { status: false, value: "Inactive" },
  ],
  ROUTE: {
    REGISTER: "/register",
    DASHBOARD: "/dashboard",
    FORGOT_PASSWORD: "/forgot-password",
    SETTINGS: "/settings",
    ONBOARDING: "/onboarding",
    VERIFICATION: "/verification",
    USER: "users",
    ROLE: "roles",
    ADD_ROLE: "create",
    EDIT_ROLE: ":id/edit",
    ROLE_DETAIL: ":id",
    MESSAGE: "messages",
    BRAND: "brands",
    TRANSPORTER: "transporters",
    UNIT_OF_MEASUREMENT: "units-of-measurement",
    TENANT: "tenants",
    WAREHOUSE: "warehouses",
    INSURER: "insurers",
    DEALER_USERS: "dealer-users",
    VENDOR: "vendors",
    ADD_VENDOR: "create",
    EDIT_VENDOR: ":id/edit",
    VENDOR_DETAIL: ":id",
    PRODUCT: "items",
    ADD_PRODUCT: "create",
    EDIT_PRODUCT: ":id/edit",
    CLONE_PRODUCT: ":id/clone",
    PRODUCT_DETAIL: ":id",
    PRODUCT_GROUP: "item-groups",
    ADD_PRODUCT_GROUP: "create",
    ADD_PRODUCT_TO_GROUP: "add-item",
    EDIT_PRODUCT_GROUP: ":id/edit",
    PRODUCT_GROUP_DETAIL: ":id",
    COMPOSITE_ITEMS: "composite-items",
    ADD_COMPOSITE_ITEMS: "create",
    EDIT_COMPOSITE_ITEMS: ":id/edit",
    CLONE_COMPOSITE_ITEMS: ":id/clone",
    COMPOSITE_ITEM_DETAIL: ":id",
    ITEM_CATEGORY: "item-categories",
    CUSTOMER_CATEGORY: "customer-categories",
    CUSTOMER_ACCOUNT_TYPE: "customer-account-types",
    ITEM_SEGMENT: "item-segments",
    PRODUCT_GROUP_MASTER: "product-groups",
    CURRENCY: "currencies",
    PURCHASE_ORDER: "purchase-orders",
    ADD_PURCHASE_ORDER: "create",
    EDIT_PURCHASE_ORDER: ":id/edit",
    PURCHASE_ORDER_DETAIL: ":id",
    PURCHASE_RECEIVE: "purchase-receipts",
    PURCHASE_RECEIVE_INVOICE: "invoice",
    PURCHASE_RECEIVE_BATCH: "batch",
    ADD_PURCHASE_RECEIVE: "create",
    ADD_PURCHASE_RECEIVE_FROM_PO: "create/:poId",
    PURCHASE_RECEIVE_DETAIL: ":id",
    PURCHASE_RECEIVE_RECEIVE: ":id/receive",
    INVOICE_RECEIVE: "invoice-receive/:invoiceNumber",
    INVOICE_RECEIVING: "invoice-receiving/:invoiceNumber",
    QR_VERIFICATION: "qr-verification/:id",
    INVOICE_QR_VERIFICATION: "invoice-qr-verification/:invoiceNumber",
    // Multi-Invoice Batch Receive (session-based)
    RECEIVE_SESSION_START: "receive-session/start",
    RECEIVE_SESSION_SCAN: "receive-session/:sessionId/scan",
    RECEIVE_SESSION_FINALIZE: "receive-session/:sessionId/finalize",
    QUOTATION: "quotations",
    ADD_QUOTATION: "create",
    EDIT_QUOTATION: ":id/edit",
    QUOTATION_DETAIL: ":id",
    SALES_ORDER: "sales-orders",
    ADD_SALES_ORDER: "create",
    EDIT_SALES_ORDER: ":id/edit",
    SALES_ORDER_DETAIL: ":id",
    COUNTER_SALE: "counter-sales",
    ADD_COUNTER_SALE: "create",
    EDIT_COUNTER_SALE: ":id/edit",
    COUNTER_SALE_DETAIL: ":id",
    COUNTER_SALE_POS: "pos",
    COUNTER_SALE_POS_EDIT: "pos/:id/edit",
    INVOICE: "invoices",
    CREATE_INVOICE: "create",
    EDIT_INVOICE: ":invoiceId/edit",
    INVOICE_DETAIL: ":id",
    // Credit Note routes
    CREDIT_NOTE: "credit-notes",
    CREATE_CREDIT_NOTE: "create",
    EDIT_CREDIT_NOTE: ":id/edit",
    CREDIT_NOTE_DETAIL: ":id",
    CUSTOMER: "customers",
    ADD_CUSTOMER: "create",
    EDIT_CUSTOMER: ":id/edit",
    CUSTOMER_DETAIL: ":id/edit",
    LOCATION: "locations",
    APPROVER: "approvers",
    TERRITORY: "territories",
    FISCAL_CALENDAR: "settings/fiscal-calendar",
    IMPORT_TEMPLATE: "settings/import-templates",
    ADD_IMPORT_TEMPLATE: "create",
    EDIT_IMPORT_TEMPLATE: ":id/edit",
    IMPORT_TEMPLATE_DETAIL: ":id",
    PICKLIST: "picklists",
    ADD_PICKLIST: "create",
    ADD_PICKLIST_FROM_SO: "create/:soId",
    EDIT_PICKLIST: ":id/edit",
    PICKLIST_DETAIL: ":id",
    TERRITORY: "territories",
    PACKAGES: "packages",
    CREATE_PACKAGE: "create",
    PACKAGE_WORKSPACE: ":packageId/edit",
    PACKAGE_DETAIL: ":id",
    TENANT_EMAIL_CONFIGURATION: "/email-configuration",
    TENANT_EMAIL_TEMPLATE: "/email-templates",
    EDIT_TENANT_EMAIL_TEMPLATE: ":emailTemplateId/edit",
    MANUFACTURER: "manufacturer",
    ADD_MANUFACTURER: "create",
    EDIT_MANUFACTURER: ":id/edit",
    DELIVERY_CHALLAN: "delivery-challans",
    ADD_DELIVERY_CHALLAN: "create",
    EDIT_DELIVERY_CHALLAN: ":id/edit",
    DELIVERY_CHALLAN_DETAIL: ":id",
    SHIPMENT: "shipment",
    ADD_SHIPMENT: "create",
    EDIT_SHIPMENT: ":id/edit",
    SHIPMENT_DETAIL: ":id",
    SALES_RETURN: "sales-returns",
    ADD_SALES_RETURN: "create",
    EDIT_SALES_RETURN: ":id/edit",
    SALES_RETURN_DETAIL: ":id",
    // Inventory Adjustment routes
    ITEM_ADJUSTMENT: "inventory-adjustments",
    ADD_ITEM_ADJUSTMENT: "create",
    EDIT_ITEM_ADJUSTMENT: ":id/edit",
    ITEM_ADJUSTMENT_DETAIL: ":id",
    // Transfer Order routes
    TRANSFER_ORDER: "transfer-orders",
    ADD_TRANSFER_ORDER: "create",
    EDIT_TRANSFER_ORDER: ":id/edit",
    TRANSFER_ORDER_DETAIL: ":id",
    // Backorder routes
    DISCOUNT_SCHEME: "discount-schemes",
    ADD_DISCOUNT_SCHEME: "create",
    EDIT_DISCOUNT_SCHEME: ":id/edit",
    BACKORDER: "backorders",
    ADD_BACKORDER: "create",
    ADD_BACKORDER_FROM_SO: "create/:soId",
    BACKORDER_DETAIL: ":id",
    EDIT_BACKORDER: "edit/:id",
    FULFILL_BACKORDERS: "fulfill/:soId",
    // Report routes
    REPORTS: "reports",
    STOCK_SUMMARY_REPORT: "reports/stock-summary",
    STOCK_VALUATION_REPORT: "reports/stock-valuation",
    LOW_STOCK_REPORT: "reports/low-stock",
    STOCK_AGING_REPORT: "reports/stock-aging",
    BIN_STOCK_REPORT: "reports/bin-stock",
    STOCK_ADJUSTMENT_REPORT: "reports/stock-adjustment",
    STOCK_LEDGER: "stock-ledger",
    PURCHASE_ORDER_REPORT: "reports/purchase-orders",
    PENDING_PO_REPORT: "reports/pending-purchase-orders",
    GOODS_RECEIPT_REPORT: "reports/goods-receipts",
    PURCHASE_VARIANCE_REPORT: "reports/purchase-variance",
    PURCHASE_REGISTER_REPORT: "reports/purchase-register",
    PURCHASE_MONTHLY_REPORT: "reports/purchase-monthly",
    SALES_ORDER_REPORT: "reports/sales-orders",
    PENDING_SO_REPORT: "reports/pending-sales-orders",
    BACKORDER_REPORT: "reports/backorders",
    SALES_BY_CUSTOMER_REPORT: "reports/sales-by-customer",
    SALES_BY_SALES_PERSON_REPORT: "reports/sales-by-sales-person",
    SALES_BY_ITEM_REPORT: "reports/sales-by-item",
    SALES_BY_CATEGORY_REPORT: "reports/sales-by-category",
    SALES_BY_BRAND_REPORT: "reports/sales-by-brand",
    SALES_BY_INVOICE_REPORT: "reports/sales-by-invoice",
    CUSTOMER_ITEM_SALES_REPORT: "reports/customer-item-sales",
    CUSTOMER_MONTHLY_SALES_REPORT: "reports/customer-monthly-sales",
    NET_SALES_REGISTER_REPORT: "reports/net-sales-register",
    BUSINESS_SALES_TRANSACTION_REPORT: "reports/business-sales-transaction",
    SALES_VS_FULFILLMENT_REPORT: "reports/sales-vs-fulfillment",
    ITEM_WISE_SALES_RETURN_REPORT: "reports/item-wise-sales-return",
    GSTR1_REPORT: "reports/gstr1",
    COUNTER_SALES_REPORT: "reports/counter-sales",
    INVOICE_REPORT: "reports/invoices",
    OUTSTANDING_INVOICE_REPORT: "reports/outstanding-invoices",
    INVOICE_AGING_REPORT: "reports/invoice-aging",
    EXPORT_HISTORY: "reports/export-history",
    UQC_MASTER: "uqc-master",
    ITEM_DEFAULT_BIN: "item-default-bins",
  },
  ADMIN_ROUTE: {
    LOGIN: "/admin/login",
    TENANT: "admin/tenants",
    ADD_TENANT: "create",
    EDIT_TENANT: ":id/edit",
    EMAIL_CONFIGURATION: ":id/provider-configuration",
    EINVOICE_CONFIGURATION: ":id/einvoice-configuration",
    TENANT_DETAIL: ":id",
    TENANT_INQUIRY: "admin/tenant-inquiries",
    ADD_TENANT_INQUIRY: "create/:id",
    EDIT_TENANT_INQUIRY: ":id/edit",
    TENANT_INQUIRY_DETAIL: ":id",
    ADD_TENANT_INQUIRY_EXTERNAL: "inquiry/:id",
    EMAIL_PROVIDER: "admin/email-providers",
    EMAIL_TEMPLATE: "admin/email-templates",
    ADD_EMAIL_TEMPLATE: "create",
    EDIT_EMAIL_TEMPLATE: ":id/edit",
  },
  REGEX: {
    WEAK_PASSWORD: "/^(?=.*[a-zA-Z]).{6,}$/",
    STRONG_PASSWORD:
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/,
    NUMERIC: /^[0-9\b]+$/,
    MOBILE: /^[0-9]+$/,
    NO_SPACE: /^[^\s](.*[^\s])?$/,
    NOT_ALLOW_SPECIAL_CHAR_DOT: /^[a-zA-Z0-9\s]*$/,
    ONLY_STRING: /^[A-Za-z]+(?: [A-Za-z]+)* *$/,
    BETWEEN: /^[A-Za-z ]{3,100}$/,
    BETWEENLONG: /^[a-zA-Z0-9\s!@#$%^&*()_+={}\[\]:;"'<>,.?\/\\|-]{0,127}$/,
    TRIM_WHITESPACE: /^(?!\s*$).+/,
    EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
  },
  DATE_FORMATS: {
    DMY: "DD MM YYYY",
    DMYHM: "DD MM YYYY HH:mm",
    DMYHMS: "DD MM YYYY HH:mm:ss",
    DMYHMA: "DD MM YYYY hh:mm A",
    DMYHMa: "DD MM YYYY hh:mm a",
    YMD: "YYYY MM DD",
    YMDHM: "YYYY MM DD HH:mm",
    YMDHMS: "YYYY MM DD HH:mm:ss",
    DMY_dash: "DD-MM-YYYY",
    MDY_dash: "MM-DD-YYYY",
    YMDHM_dash: "YYYY-MM-DD HH:mm",
    YMDHMS_dash: "YYYY-MM-DD HH:mm:ss",
    YMD_dash: "YYYY-MM-DD",
    DMY_slash: "DD/MM/YYYY",
    DMYHMS_slash: "DD/MM/YYYY HH:mm:ss",
  },
  USER_TYPE: {
    BACK_OFFICE: 2,
  },
  MODULE_CODE: {
    DASHBOARD: "Dashboard",
    USER: "User",
    ROLE: "Role",
    BRAND: "Brand",
    TRANSPORTER: "Transporter",
    UNIT_OF_MEASUREMENT: "UnitOfMeasurement",
    WAREHOUSE: "Warehouse",
    TENANT: "Tenant",
    TENANT_INQUIRY: "TenantInquiry",
    INSURER: "Insurer",
    DEALER_USERS: "DealerUser",
    VENDOR: "Vendor",
    PRODUCT: "Item",
    PRODUCT_GROUP: "ItemGroup",
    CATEGORY: "Category",
    CURRENCY: "Currency",
    MESSAGE: "Message",
    HISTORY: "History",
    CUSTOMER: "Customer",
    QUOTATION: "Quotation",
    PURCHASE_ORDER: "PurchaseOrder",
    PURCHASE_RECEIVE: "PurchaseReceive",
    SALES_ORDER: "SalesOrder",
    COUNTER_SALES: "CounterSales",
    INVOICE: "Invoice",
    LOCATION: "Location",
    LOCATION_ACCESS: "LocationAccess",
    APPROVER: "ApproverList",
    ORG_SETTINGS: "OrgSetting",
    PICKLIST: "Picklist",
    TERRITORY: "Territory",
    ORG_SETTINGS: "OrgSetting",
    FISCAL_CALENDAR: "FiscalCalendar",
    PACKAGE: "Package",
    EMAIL_PROVIDER: "EmailProvider",
    EMAIL_TEMPLATE: "EmailTemplate",
    TENANT_EMAIL_TEMPLATE: "TenantEmailTemplate",
    TENANT_EMAIL_CONFIGURATION: "TenantEmailConfiguration",
    EMAIL_TEMPLATE_PLACEHOLDER: "EmailTemplatePlaceholder",
    MANUFACTURER: "Manufacturer",
    DELIVERY_CHALLAN: "DeliveryChallan",
    SHIPMENT: "Shipment",
    SALES_RETURN: "SalesReturn",
    ITEM_ADJUSTMENT: "ItemAdjustment",
    TRANSFER_ORDER: "TransferOrder",
    BACKORDER: "Backorder",
    IMPORT_TEMPLATE: "ImportTemplate",
    SALES_CREDIT_NOTE: "CreditNote",
    STOCK_REPORT: "StockReport",
    STOCK_SUMMARY_REPORT: "StockSummaryReport",
    STOCK_VALUATION_REPORT: "StockValuationReport",
    PURCHASE_REPORT: "PurchaseReport",
    SALES_REPORT: "SalesReport",
    INVOICE_REPORT: "InvoiceReport",
    GSTR_REPORT: "GSTRReport",
    REPORT_EXPORT: "ReportExport",
    COUNTER_SALES_REPORT: "CounterSalesReport",
    DISCOUNT_SCHEME: "DiscountScheme",
    CUSTOMER_ACCOUNT_TYPE: "CustomerAccountType",
    ITEM_SEGMENT: "ItemSegment",
    PRODUCT_GROUP_MASTER: "ProductGroup",
    UQC_MASTER: "UQCMaster",
    ITEM_DEFAULT_BIN: "ItemDefaultBin",
  },
  MODULE_PERMISSION: {
    VIEW: "View",
    CREATE: "Create",
    EDIT: "Edit",
    DELETE: "Delete",
    APPROVE: "Approve",
    REJECT: "Reject",
    DOWNLOAD: "Download",
    CLOSE: "Close",
  },
  OTP_VALUE: {
    FORGOT_PASSWORD: 1,
    REGISTRATION: 0,
  },
  CUSTOMIZE_MESSAGE: {
    CHARACTER_LENGTH: 2000,
  },
  FISCAL_MONTH_OPTIONS: [
    { id: 1, name: "Jan to Dec" },
    { id: 2, name: "Feb to Jan" },
    { id: 3, name: "March to Feb" },
    { id: 4, name: "April to March" },
    { id: 5, name: "May to April" },
    { id: 6, name: "June to May" },
    { id: 7, name: "July to June" },
    { id: 8, name: "Aug to July" },
    { id: 9, name: "Sep to Aug" },
    { id: 10, name: "Oct to Sep" },
    { id: 11, name: "Nov to Oct" },
    { id: 12, name: "Dec to Nov" },
  ],
  FISCAL_YEAR_TYPE: {
    REGULAR: 1,
    SHORT: 2,
    LONG: 3,
    TRANSITIONAL: 4,
  },
  FISCAL_YEAR_TYPE_OPTIONS: [
    { id: 1, name: "Regular" },
    { id: 2, name: "Short" },
    { id: 3, name: "Long" },
    { id: 4, name: "Transitional" },
  ],
  FISCAL_YEAR_TYPE_MAPPING: {
    1: "Regular",
    2: "Short",
    3: "Long",
    4: "Transitional",
  },
  FISCAL_YEAR_STATUS: {
    ACTIVE: 1,
    CLOSED: 2,
  },
  FISCAL_YEAR_STATUS_MAPPING: {
    1: "Active",
    2: "Closed",
  },
  FISCAL_YEAR_STATUS_CONFIG: {
    1: { label: "Active", color: "success" },
    2: { label: "Closed", color: "default" },
  },
  PURCHASE_ORDER_STATUS: {
    DRAFT: 1,
    PENDING: 2,
    ISSUED: 3,
    COMPLETED: 4,
    CANCELLED: 5,
    PARTIALLY_RECEIVED: 6,
  },
  PURCHASE_ORDER_STATUS_MAPPING: {
    1: "Draft",
    2: "Pending",
    3: "Issued",
    4: "Completed",
    5: "Cancelled",
    6: "Partially Received",
  },
  // SalesOrderStatus enum - synced with backend API
  // Backend enum: Draft=1, Pending=2, Confirmed=3, Closed=4, Cancelled=5, Voided=6
  SALES_ORDER_STATUS: {
    DRAFT: 1,
    PENDING: 2,
    CONFIRMED: 3,
    CLOSED: 4,
    CANCELLED: 5,
    VOIDED: 6,
  },
  SALES_ORDER_STATUS_MAPPING: {
    1: "Draft",
    2: "Pending",
    3: "Confirmed",
    4: "Closed",
    5: "Cancelled",
    6: "Voided",
  },
  // Status display configuration (color and label)
  SALES_ORDER_STATUS_CONFIG: {
    1: { color: "default", label: "Draft" },
    2: { color: "warning", label: "Pending" },
    3: { color: "processing", label: "Confirmed" },
    4: { color: "success", label: "Closed" },
    5: { color: "error", label: "Cancelled" },
    6: { color: "purple", label: "Voided" },
  },
  // Quotation
  QUOTATION_STATUS: {
    DRAFT: 1,
    SENT: 2,
    ACCEPTED: 3,
    REJECTED: 4,
    CANCELLED: 5,
    CONVERTED: 6,
  },
  QUOTATION_STATUS_MAPPING: {
    1: "Draft",
    2: "Sent",
    3: "Accepted",
    4: "Rejected",
    5: "Cancelled",
    6: "Converted",
  },
  QUOTATION_STATUS_CONFIG: {
    1: { color: "default", label: "Draft" },
    2: { color: "blue", label: "Sent" },
    3: { color: "success", label: "Accepted" },
    4: { color: "error", label: "Rejected" },
    5: { color: "error", label: "Cancelled" },
    6: { color: "purple", label: "Converted" },
  },
  QUOTATION_VERSION_STATUS_CONFIG: {
    1: { color: "default", label: "Draft" },
    2: { color: "blue", label: "Sent" },
    3: { color: "warning", label: "Superseded" },
    98: { color: "error", label: "Rejected" },
    99: { color: "success", label: "Accepted" },
  },
  // Counter Sale
  COUNTER_SALE_STATUS: {
    DRAFT: 1,
    POSTED: 2,
    CANCELLED: 3,
  },
  COUNTER_SALE_STATUS_MAPPING: {
    1: "Draft",
    2: "Posted",
    3: "Cancelled",
  },
  COUNTER_SALE_STATUS_CONFIG: {
    1: { color: "default", label: "Draft" },
    2: { color: "success", label: "Posted" },
    3: { color: "error", label: "Cancelled" },
  },
  COUNTER_SALE_CANCELLATION_REASON: {
    CUSTOMER_CHANGED_MIND: 1,
    WRONG_ITEM: 2,
    DATA_ENTRY_ERROR: 3,
    OTHER: 4,
  },
  COUNTER_SALE_CANCELLATION_REASON_OPTIONS: [
    { value: 1, label: "Customer Changed Mind" },
    { value: 2, label: "Wrong Item" },
    { value: 3, label: "Data Entry Error" },
    { value: 4, label: "Other" },
  ],
  DELIVER_TO_TYPE: {
    LOCATION: 1,
    CUSTOMER: 2,
  },
  INVENTORY_VALUTION_METHOD: {
    1: "FIFO",
    2: "FEFO",
    3: "Weighted Average",
  },
  LOCATION_TYPE: {
    BUSINESS: 1,
    WAREHOUSE: 2,
  },
  LOCATION_TYPE_MAPPING: {
    1: "Business Location",
    2: "Warehouse Location",
  },
  ITEM_TYPE: {
    1: "Simple",
    2: "Bundle",
    3: "Kit",
  },
  DEFAULT_CURRENCY_ID: "F6002712-2D97-4AA2-AF5E-2AA0121DA87D", // INR
  TENANT_INQUIRY_STATUS_TYPE: {
    DRAFT: 1,
    SUBMITTED: 2,
    APPROVED: 3,
    REJECTED: 4,
    CLOSED: 5,
  },
  INVOICE_TYPE: {
    REGULAR: 1,
    ADVANCE: 2,
  },
  INVOICE_TYPE_OPTIONS: [
    { value: 1, label: "Regular" },
    { value: 2, label: "Advance" },
  ],
  // PurchaseOrderRoundOffMode enum - synced with backend API (tenant setting)
  // Backend enum: Manual=1, Auto=2
  PO_ROUND_OFF_MODE: {
    MANUAL: 1,
    AUTO: 2,
  },
  // InvoiceStatus enum - synced with backend API
  // Backend enum: Draft=0, Posted=1, Cancelled=2, PartiallyPaid=3, Paid=4
  INVOICE_STATUS: {
    DRAFT: 0,
    POSTED: 1,
    CANCELLED: 2,
    PARTIALLY_PAID: 3,
    PAID: 4,
  },
  INVOICE_STATUS_MAPPING: {
    0: "Draft",
    1: "Posted",
    2: "Cancelled",
    3: "Partially Paid",
    4: "Paid",
  },
  INVOICE_STATUS_CONFIG: {
    0: { label: "Draft", color: "default" },
    1: { label: "Posted", color: "processing" },
    2: { label: "Cancelled", color: "error" },
    3: { label: "Partially Paid", color: "warning" },
    4: { label: "Paid", color: "success" },
  },
  // Delivery Challan status enum - synced with backend
  // Backend: Draft=1, Confirmed=2, Dispatched=3, Cancelled=4, Closed=5, Invoiced=6
  DELIVERY_CHALLAN_STATUS: {
    1: { label: "Draft", color: "orange" },
    2: { label: "Confirmed", color: "blue" },
    3: { label: "Dispatched", color: "cyan" },
    4: { label: "Cancelled", color: "red" },
    5: { label: "Closed", color: "default" },
    6: { label: "Invoiced", color: "green" },
  },
  // Delivery Challan reason type enum - synced with backend
  // Backend: Sale=1, JobWork=2, Demo=3, Transfer=4, Return=5
  DELIVERY_CHALLAN_REASON_TYPE: {
    1: { label: "Sale", color: "blue" },
    2: { label: "Job Work", color: "purple" },
    3: { label: "Demo", color: "orange" },
    4: { label: "Transfer", color: "cyan" },
    5: { label: "Return", color: "green" },
  },
  // Picklist status enum - synced with backend API
  // Backend returns numeric values: 1=YetToStart, 2=InProgress, 3=Picked, 4=Cancelled
  PICKLIST_STATUS: {
    YET_TO_START: 1,
    IN_PROGRESS: 2,
    PICKED: 3,
    CANCELLED: 4,
    SHORT_PICKED: 5,
  },
  PICKLIST_STATUS_LABEL: {
    1: "Yet To Start",
    2: "In Progress",
    3: "Picked",
    4: "Cancelled",
    5: "Short Picked",
  },
  PICKLIST_STATUS_CONFIG: {
    1: { label: "Yet To Start", color: "default" },
    2: { label: "In Progress", color: "processing" },
    3: { label: "Picked", color: "success" },
    4: { label: "Cancelled", color: "error" },
    5: { label: "Short Picked", color: "warning" },
  },
  // Aggregated package coverage on the picklist (PicklistPackageStatus enum on the BE).
  // Persisted on Picklist row, kept in sync by IPicklistPackageStatusUpdater. NULL on
  // Cancelled picklists — the FE renders a dash for that case.
  PICKLIST_PACKAGE_STATUS: {
    NOT_PACKED: 1,
    PARTIALLY_PACKED: 2,
    PACKED: 3,
  },
  PICKLIST_PACKAGE_STATUS_CONFIG: {
    1: { label: "Not Packed", color: "default" },
    2: { label: "Partially Packed", color: "warning" },
    3: { label: "Packed", color: "success" },
  },
  PICK_COMPLETION_MODE: {
    SAVE_PROGRESS: 1,
    COMPLETE_PICK: 2,
  },
  SHORT_PICK_REASON: {
    NOT_FOUND: 1,
    DAMAGED: 2,
    INVENTORY_MISMATCH: 3,
    OTHER: 4,
  },
  SHORT_PICK_REASON_LABEL: {
    1: "Not Found",
    2: "Damaged",
    3: "Inventory Mismatch",
    4: "Other",
  },
  // Package status enum
  PACKAGE_STATUS: {
    DRAFT: 1,
    PACKED: 2,
    CANCELLED: 3,
  },
  PACKAGE_STATUS_CONFIG: {
    1: { label: "Draft", color: "default" },
    2: { label: "Packed", color: "processing" },
    3: { label: "Cancelled", color: "error" },
  },
  // Box status enum
  BOX_STATUS: {
    DRAFT: 1,
    CLOSED: 2,
  },
  BOX_STATUS_CONFIG: {
    1: { label: "Draft", color: "default" },
    2: { label: "Closed", color: "success" },
  },
  // Shipment status enum
  SHIPMENT_STATUS: {
    CREATED: 1,
    DISPATCHED: 2,
    DELIVERED: 3,
    VOID: 4,
    CANCELLED: 5,
  },
  SHIPMENT_STATUS_MAPPING: {
    1: "Created",
    2: "Dispatched",
    3: "Delivered",
    4: "Void",
    5: "Cancelled",
  },
  // ============================================
  // Sales Order Fulfillment Status Enums
  // These are denormalized statuses for quick list filtering
  // ============================================

  // SalesOrderPackageStatus - synced with backend API
  // Backend enum: NotPacked=1, PartiallyPacked=2, Packed=3
  SALES_ORDER_PACKAGE_STATUS: {
    NOT_PACKED: 1,
    PARTIALLY_PACKED: 2,
    PACKED: 3,
  },
  SALES_ORDER_PACKAGE_STATUS_MAPPING: {
    1: "Not Packed",
    2: "Partially Packed",
    3: "Packed",
  },
  SALES_ORDER_PACKAGE_STATUS_CONFIG: {
    1: { label: "Not Packed", color: "default" },
    2: { label: "Partially Packed", color: "warning" },
    3: { label: "Packed", color: "success" },
  },

  // SalesOrderInvoiceStatus - synced with backend API
  // Backend enum: NotInvoiced=1, PartiallyInvoiced=2, Invoiced=3
  SALES_ORDER_INVOICE_STATUS: {
    NOT_INVOICED: 1,
    PARTIALLY_INVOICED: 2,
    INVOICED: 3,
  },
  SALES_ORDER_INVOICE_STATUS_MAPPING: {
    1: "Not Invoiced",
    2: "Partially Invoiced",
    3: "Invoiced",
  },
  SALES_ORDER_INVOICE_STATUS_CONFIG: {
    1: { label: "Not Invoiced", color: "default" },
    2: { label: "Partially Invoiced", color: "warning" },
    3: { label: "Invoiced", color: "success" },
  },

  // CancellationReason - synced with backend API
  // Backend enum: CustomerRequested=1, OutOfStock=2, PricingError=3, DuplicateOrder=4, Other=5
  CANCELLATION_REASON: {
    CUSTOMER_REQUESTED: 1,
    OUT_OF_STOCK: 2,
    PRICING_ERROR: 3,
    DUPLICATE_ORDER: 4,
    OTHER: 5,
  },
  CANCELLATION_REASON_OPTIONS: [
    { value: 1, label: "Customer Requested" },
    { value: 2, label: "Out of Stock" },
    { value: 3, label: "Pricing Error" },
    { value: 4, label: "Duplicate Order" },
    { value: 5, label: "Other" },
  ],

  // SalesOrderShipmentStatus - synced with backend API
  // Backend enum: NotShipped=1, PartiallyShipped=2, Shipped=3, Fulfilled=4
  SALES_ORDER_SHIPMENT_STATUS: {
    NOT_SHIPPED: 1,
    PARTIALLY_SHIPPED: 2,
    SHIPPED: 3,
    FULFILLED: 4,
  },
  SALES_ORDER_SHIPMENT_STATUS_MAPPING: {
    1: "Not Shipped",
    2: "Partially Shipped",
    3: "Shipped",
    4: "Fulfilled",
  },
  SALES_ORDER_SHIPMENT_STATUS_CONFIG: {
    1: { label: "Not Shipped", color: "default" },
    2: { label: "Partially Shipped", color: "warning" },
    3: { label: "Shipped", color: "processing" },
    4: { label: "Fulfilled", color: "success" },
  },

  // ============================================
  // Sales Return Status Enums
  // ============================================
  SALES_RETURN_STATUS: {
    CREATED: 1,
    APPROVED: 2,
  },
  SALES_RETURN_STATUS_MAPPING: {
    1: "Created",
    2: "Approved",
  },
  SALES_RETURN_STATUS_CONFIG: {
    1: { label: "Created", color: "default" },
    2: { label: "Approved", color: "success" },
  },

  // Sales Return Type Enums
  SALES_RETURN_TYPE: {
    PHYSICAL: 1,
    FINANCIAL_ADJUSTMENT: 2,
  },
  SALES_RETURN_TYPE_MAPPING: {
    1: "Physical",
    2: "Financial Adjustment",
  },
  SALES_RETURN_TYPE_CONFIG: {
    1: {
      label: "Physical Return",
      color: "processing",
      description: "Goods will be returned",
    },
    2: {
      label: "Financial Adjustment Only",
      color: "purple",
      description: "No physical return",
    },
  },

  // Sales Return Reason Types
  SALES_RETURN_REASON_TYPE: {
    DEFECTIVE: 1,
    WRONG_ITEM: 2,
    DAMAGED: 3,
    QUALITY_ISSUE: 4,
    NOT_AS_DESCRIBED: 5,
    EXCESS_QUANTITY: 6,
    OTHER: 99,
  },
  SALES_RETURN_REASON_OPTIONS: [
    { value: 1, label: "Defective Product" },
    { value: 2, label: "Wrong Item Shipped" },
    { value: 3, label: "Damaged in Transit" },
    { value: 4, label: "Quality Issue" },
    { value: 5, label: "Not as Described" },
    { value: 6, label: "Excess Quantity" },
    { value: 99, label: "Other" },
  ],

  // Sales Return Write-off Reasons (for approval)
  SALES_RETURN_WRITEOFF_REASONS: [
    "Damaged - Cannot be resold",
    "Defective - Quality control rejected",
    "Expired product",
    "Missing parts or incomplete",
    "Contaminated or unsafe",
    "Customer damaged",
    "Other",
  ],

  // ============================================
  // Credit Note Enums (matching backend SalesCreditNote DTOs)
  // ============================================
  CREDIT_NOTE_STATUS: {
    DRAFT: 1,
    ISSUED: 2,
    CANCELLED: 3,
  },
  CREDIT_NOTE_STATUS_MAPPING: {
    1: "Draft",
    2: "Issued",
    3: "Cancelled",
  },
  CREDIT_NOTE_STATUS_CONFIG: {
    1: { label: "Draft", color: "default" },
    2: { label: "Issued", color: "success" },
    3: { label: "Cancelled", color: "error" },
  },
  // SalesCreditNoteTypeDto
  CREDIT_NOTE_TYPE: {
    SALES_RETURN: 1,
    PRICE_ADJUSTMENT: 2,
  },
  CREDIT_NOTE_MODE: {
    ITEM_WISE: 1,
    OVERALL_DISCOUNT: 2,
  },
  CREDIT_NOTE_TYPE_MAPPING: {
    1: "Sales Return",
    2: "Price Adjustment",
  },
  // SalesCreditNoteReasonTypeForPricingDto - Used when CreditNoteType is PriceAdjustment
  CREDIT_NOTE_REASON_TYPE_PRICING: {
    PRICE_CORRECTION: 1,
    POST_INVOICE_DISCOUNT: 2,
    COMMERCIAL_SETTLEMENT: 3,
    BILLING_ERROR: 4,
    OTHER: 99,
  },
  CREDIT_NOTE_REASON_OPTIONS_PRICING: [
    { value: 1, label: "Price correction" },
    { value: 2, label: "Post-invoice discount" },
    { value: 3, label: "Commercial settlement" },
    { value: 4, label: "Billing error" },
    { value: 99, label: "Other" },
  ],
  // SalesCreditNoteReasonTypeForQuantityDto - Used when CreditNoteType is SalesReturn
  CREDIT_NOTE_REASON_TYPE_QUANTITY: {
    GOODS_RETURNED: 1,
    SHORT_SUPPLIED: 2,
    DAMAGED_GOODS: 3,
    WRONG_ITEM_SUPPLIED: 4,
    WARRANTY_DEFECTIVE: 5,
    OTHER: 99,
  },
  CREDIT_NOTE_REASON_OPTIONS_QUANTITY: [
    { value: 1, label: "Goods returned" },
    { value: 2, label: "Short supplied" },
    { value: 3, label: "Damaged goods" },
    { value: 4, label: "Wrong item supplied" },
    { value: 5, label: "Warranty / Defective" },
    { value: 99, label: "Other" },
  ],

  // ============================================
  // Item Transaction Type Enums
  // ============================================
  ITEM_TRANSACTION_TYPE: {
    PURCHASE_ORDER: "PurchaseOrder",
    PURCHASE_RECEIVE: "PurchaseReceive",
    SALES_ORDER: "SalesOrder",
    INVOICE: "Invoice",
    SALES_RETURN: "SalesReturn",
    INVENTORY: "Inventory",
  },
  ITEM_TRANSACTION_TYPE_OPTIONS: [
    { value: "PurchaseOrder", label: "Purchase Order" },
    { value: "PurchaseReceive", label: "Purchase Receive" },
    { value: "SalesOrder", label: "Sales Order" },
    { value: "Invoice", label: "Invoice" },
    { value: "SalesReturn", label: "Sales Return" },
    // { value: "Inventory", label: "Inventory" }, // Hidden for now
  ],
  ITEM_TRANSACTION_TYPE_CONFIG: {
    PurchaseOrder: { label: "Purchase Order", color: "blue" },
    PurchaseReceive: { label: "Purchase Receive", color: "geekblue" },
    SalesOrder: { label: "Sales Order", color: "purple" },
    Invoice: { label: "Invoice", color: "orange" },
    SalesReturn: { label: "Sales Return", color: "cyan" },
    Inventory: { label: "Inventory", color: "default" },
  },

  // Item Transaction Status Config (generic status display)
  ITEM_TRANSACTION_STATUS_CONFIG: {
    Draft: { label: "Draft", color: "default" },
    Pending: { label: "Pending", color: "warning" },
    Approved: { label: "Approved", color: "success" },
    Confirmed: { label: "Confirmed", color: "processing" },
    Issued: { label: "Issued", color: "processing" },
    Completed: { label: "Completed", color: "success" },
    Cancelled: { label: "Cancelled", color: "error" },
    Received: { label: "Received", color: "success" },
    Paid: { label: "Paid", color: "success" },
    Sent: { label: "Sent", color: "processing" },
    Unknown: { label: "Unknown", color: "default" },
  },

  // Item Transaction Drill-Down Routes
  ITEM_TRANSACTION_ROUTES: {
    PurchaseOrder: "/purchase-orders",
    PurchaseReceive: "/purchase-receipts",
    SalesOrder: "/sales-orders",
    Invoice: "/invoices",
    SalesReturn: "/sales-returns",
    Inventory: "/inventory/transactions",
  },

  // ============================================
  // Item Adjustment Status Enums
  // ============================================
  ITEM_ADJUSTMENT_STATUS: {
    DRAFT: 1,
    SUBMITTED: 2,
    APPROVED: 3,
    POSTED: 4,
    REJECTED: 5,
    CANCELLED: 6,
  },
  ITEM_ADJUSTMENT_STATUS_MAPPING: {
    1: "Draft",
    2: "Submitted",
    3: "Approved",
    4: "Posted",
    5: "Rejected",
    6: "Cancelled",
  },
  ITEM_ADJUSTMENT_STATUS_CONFIG: {
    1: { label: "Draft", color: "default" },
    2: { label: "Submitted", color: "processing" },
    3: { label: "Approved", color: "success" },
    4: { label: "Posted", color: "cyan" },
    5: { label: "Rejected", color: "error" },
    6: { label: "Cancelled", color: "error" },
  },

  // Item Adjustment Type Enums
  ITEM_ADJUSTMENT_TYPE: {
    QUANTITY_ADJUSTMENT: 1,
    VALUE_ADJUSTMENT: 2,
  },
  ITEM_ADJUSTMENT_TYPE_MAPPING: {
    1: "Quantity Adjustment",
    2: "Value Adjustment",
  },
  ITEM_ADJUSTMENT_TYPE_CONFIG: {
    1: { label: "Quantity Adjustment", color: "blue" },
    2: { label: "Value Adjustment", color: "green" },
  },
  ITEM_ADJUSTMENT_TYPE_OPTIONS: [
    { value: 1, label: "Quantity Adjustment" },
    { value: 2, label: "Value Adjustment" },
  ],

  // Item Adjustment Line Status
  ITEM_ADJUSTMENT_LINE_STATUS: {
    PENDING: 1,
    POSTED: 2,
    SKIPPED: 3,
  },
  ITEM_ADJUSTMENT_LINE_STATUS_CONFIG: {
    1: { label: "Pending", color: "default" },
    2: { label: "Posted", color: "success" },
    3: { label: "Skipped", color: "warning" },
  },

  // ============================================
  // Transfer Order Status Enums
  // ============================================
  TRANSFER_ORDER_STATUS: {
    DRAFT: 1,
    IN_TRANSIT: 2,
    TRANSFERRED: 3,
    CANCELLED: 4,
  },
  TRANSFER_ORDER_STATUS_MAPPING: {
    1: "Draft",
    2: "In Transit",
    3: "Transferred",
    4: "Cancelled",
  },
  TRANSFER_ORDER_STATUS_CONFIG: {
    1: { label: "Draft", color: "default" },
    2: { label: "In Transit", color: "processing" },
    3: { label: "Transferred", color: "success" },
    4: { label: "Cancelled", color: "error" },
  },

  // Transfer Order Item Status
  TRANSFER_ORDER_ITEM_STATUS: {
    PENDING: 1,
    SHIPPED: 2,
    RECEIVED: 3,
    SKIPPED: 4,
  },
  TRANSFER_ORDER_ITEM_STATUS_CONFIG: {
    1: { label: "Pending", color: "default" },
    2: { label: "Shipped", color: "processing" },
    3: { label: "Received", color: "success" },
    4: { label: "Skipped", color: "warning" },
  },

  // ============================================
  // Backorder Status Enums
  // ============================================
  BACKORDER_STATUS: {
    OPEN: 1,
    ATTENTION_REQUIRED: 2,
    IN_PROGRESS: 3,
    FULFILLED: 4,
    CLOSED: 5,
    CANCELLED: 6,
  },
  BACKORDER_STATUS_MAPPING: {
    1: "Open",
    2: "Attention Required",
    3: "In Progress",
    4: "Fulfilled",
    5: "Closed",
    6: "Cancelled",
  },
  BACKORDER_STATUS_CONFIG: {
    1: { label: "Open", color: "default" },
    2: { label: "Attention Required", color: "warning" },
    3: { label: "In Progress", color: "processing" },
    4: { label: "Fulfilled", color: "success" },
    5: { label: "Closed", color: "error" },
    6: { label: "Cancelled", color: "error" },
  },

  // Backorder Item Status
  BACKORDER_ITEM_STATUS: {
    OPEN: 1,
    ATTENTION_REQUIRED: 2,
    IN_PROGRESS: 3,
    FULFILLED: 4,
    CANCELLED: 5,
  },
  BACKORDER_ITEM_STATUS_MAPPING: {
    1: "Open",
    2: "Attention Required",
    3: "In Progress",
    4: "Fulfilled",
    5: "Cancelled",
  },
  BACKORDER_ITEM_STATUS_CONFIG: {
    1: { label: "Open", color: "default" },
    2: { label: "Attention Required", color: "warning" },
    3: { label: "In Progress", color: "processing" },
    4: { label: "Fulfilled", color: "success" },
    5: { label: "Cancelled", color: "error" },
  },
  PAYMENT_MODES: {
    1: "Cash",
    2: "Cheque",
    3: "BankTransfer",
    4: "UPI",
    5: "CreditCard",
    6: "DebitCard",
    7: "Other",
  },

  // ============================================
  // Import Template Enums
  // ============================================

  // Supported entity types for import
  IMPORT_ENTITY_TYPE: {
    PURCHASE_ORDER: "PurchaseOrder",
    ITEM: "Item",
    VENDOR: "Vendor",
    ITEM_DEFAULT_BIN: "ItemDefaultBin",
    PURCHASE_RECEIVE: "PurchaseReceive",
    SALES_ORDER: "SalesOrder",
    OPENING_STOCK: "OpeningStock",
    STOCK_ADJUSTMENT: "StockAdjustment",
  },
  IMPORT_ENTITY_TYPE_OPTIONS: [
    { value: "PurchaseOrder", label: "Purchase Order" },
    { value: "Item", label: "Item" },
    { value: "Vendor", label: "Vendor" },
    { value: "ItemDefaultBin", label: "Item Default Bin" },
    { value: "PurchaseReceive", label: "Purchase Receive" },
    { value: "SalesOrder", label: "Sales Order" },
    { value: "OpeningStock", label: "Opening Stock" },
    { value: "StockAdjustment", label: "Stock Adjustment" },
  ],
  IMPORT_ENTITY_TYPE_CONFIG: {
    PurchaseOrder: {
      label: "Purchase Order",
      color: "blue",
      isMultiTable: true,
      targetTables: {
        Header: "PurchaseOrder",
        Line: "PurchaseOrderLine",
      },
    },
    Item: {
      label: "Item",
      color: "green",
      isMultiTable: false,
      targetTables: {
        default: "Item",
      },
    },
    Vendor: {
      label: "Vendor",
      color: "purple",
      isMultiTable: false,
      targetTables: {
        default: "Vendor",
      },
    },
    ItemDefaultBin: {
      label: "Item Default Bin",
      color: "cyan",
      isMultiTable: false,
      targetTables: {
        default: "ItemLocation",
      },
    },
    PurchaseReceive: {
      label: "Goods Receipt",
      color: "orange",
      isMultiTable: true,
      targetTables: {
        Header: "PurchaseReceive",
        Line: "PurchaseReceiveItem",
      },
    },
    SalesOrder: {
      label: "Sales Order",
      color: "magenta",
      isMultiTable: true,
      targetTables: {
        Header: "SalesOrder",
        Line: "SalesOrderItem",
      },
    },
    OpeningStock: {
      label: "Opening Stock",
      color: "gold",
      isMultiTable: false,
      targetTables: {
        default: "OpeningStock",
      },
    },
    StockAdjustment: {
      label: "Stock Adjustment",
      color: "volcano",
      isMultiTable: false,
      targetTables: {
        Header: "StockAdjustment",
      },
    },
  },

  // Field levels for multi-table imports
  IMPORT_FIELD_LEVEL: {
    HEADER: "Header",
    LINE: "Line",
  },
  IMPORT_FIELD_LEVEL_OPTIONS: [
    { value: "Header", label: "Header" },
    { value: "Line", label: "Line" },
  ],

  // Types of default values
  DEFAULT_VALUE_TYPE: {
    STATIC: "Static",
    LOOKUP: "Lookup",
    CURRENT_USER: "CurrentUser",
    CURRENT_DATE: "CurrentDate",
    EXPRESSION: "Expression",
  },
  DEFAULT_VALUE_TYPE_OPTIONS: [
    { value: "Static", label: "Static Value" },
    { value: "Lookup", label: "Lookup from Master Data" },
    { value: "CurrentUser", label: "Current User" },
    { value: "CurrentDate", label: "Current Date" },
    { value: "Expression", label: "Expression (Computed)" },
  ],

  // When to apply default
  USE_DEFAULT_WHEN: {
    ALWAYS: "Always",
    WHEN_EMPTY: "WhenEmpty",
    WHEN_COLUMN_MISSING: "WhenColumnMissing",
  },
  USE_DEFAULT_WHEN_OPTIONS: [
    { value: "Always", label: "Always use default" },
    { value: "WhenEmpty", label: "When cell is empty" },
    { value: "WhenColumnMissing", label: "When column is missing" },
  ],

  // Lookup entity types (for master data fields)
  LOOKUP_ENTITY_TYPE: {
    VENDOR: "Vendor",
    CUSTOMER: "Customer",
    ITEM: "Item",
    LOCATION: "Location",
    UOM: "UnitOfMeasurement",
    ITEM_CATEGORY: "ItemCategory",
    CURRENCY: "Currency",
    STATE: "State",
  },
  LOOKUP_ENTITY_TYPE_OPTIONS: [
    { value: "Vendor", label: "Vendor" },
    { value: "Customer", label: "Customer" },
    { value: "Item", label: "Item" },
    { value: "Location", label: "Location" },
    { value: "UnitOfMeasurement", label: "Unit of Measurement" },
    { value: "ItemCategory", label: "Discount Category" },
    { value: "Currency", label: "Currency" },
    { value: "State", label: "State" },
  ],

  // Lookup match field options per entity type
  // Defines which field to use when matching source values to system records
  LOOKUP_MATCH_FIELD_OPTIONS: {
    Item: [
      { value: "Name", label: "Item Name" },
      { value: "SKU", label: "SKU" },
    ],
  },

  // ============================================
  // Report Export Enums
  // ============================================
  REPORT_EXPORT_STATUS: {
    QUEUED: 1,
    PROCESSING: 2,
    COMPLETED: 3,
    FAILED: 4,
    EXPIRED: 5,
  },
  REPORT_EXPORT_STATUS_CONFIG: {
    1: { label: "Queued", color: "default" },
    2: { label: "Processing", color: "processing" },
    3: { label: "Completed", color: "success" },
    4: { label: "Failed", color: "error" },
    5: { label: "Expired", color: "warning" },
  },
  REPORT_EXPORT_FORMAT: {
    CSV: 1,
    EXCEL: 2,
    PDF: 3,
  },
  REPORT_EXPORT_FORMAT_CONFIG: {
    1: { label: "CSV", color: "default" },
    2: { label: "Excel", color: "processing" },
    3: { label: "PDF", color: "error" },
  },
};

export const PURCHASE_RECEIVE_SHORTAGE_REASONS = [
  "Missing from shipment",
  "Boxes not loaded",
  "Lost in transit",
  "Carrier damage - undeliverable",
  "Vendor short-shipped",
  "Other",
];

export const PURCHASE_RECEIVE_REJECTION_REASONS = [
  "Damaged packaging",
  "Damaged product",
  "Wrong item received",
  "Expired product",
  "Quality defect",
  "Other",
];
